import { Card, CardMedia, Divider, Grid } from '@material-ui/core';
import {
  getInfosIndividual,
  getInfosDashboard,
  getProfilePreferences,
  getProfilePresentation,
  updateProfilePreferencesIndivudual,
} from '@webapps/business';
import { Button, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { Component, useEffect, useState } from 'react';

import Achievement from './Components/Achievement';
import Certification from './Components/Certification';
import CompetenciesPerso from './Components/CompetenciesPerso';
import CompetenciesPro from './Components/CompetenciesPro';
import Contact from './Components/Contact';
import Criteria from './Components/Criteria';
import Description from './Components/Description';
import Education from './Components/Education';
import Experience from './Components/Experience';
import Interest from './Components/Interest';
import Language from './Components/Language';
import LanguageProg from './Components/LanguageProg';
import Permit from './Components/Permit';
import ProfilName from './Components/ProfilName';
import Software from './Components/Software';
import Transport from './Components/Transport';
import theme from './theme';
import DetailedSkeleton from './DetailedSkeleton';

const Detailed = ({ info, closeModal, shareClassroom = false }) => {

  if (!info.id) {
    return <DetailedSkeleton shareClassroom={shareClassroom} />;
  }

  const {
    coverImage,
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const {
    images: { DefaultHeader },
  } = theme;

  const [testcoverImageUrl, setTestCoverImageUrl] = useState(coverImage);

  const { data: { coverImageUrl = '' } = {}, refetch: refetchCoverImg } =
    useQuery(getProfilePresentation, {
      key: 'coverImageUrl' + info?.id,
      variables: { id: info?.id },
      onSuccess: (data) => {
        setTestCoverImageUrl(coverImageUrl);
      },
    });

  return (
    <div className={classes.container}>
      <Card elevation={0} style={{ position: 'relative', borderRadius: shareClassroom ? "0px" : "4px" }}>
        <CardMedia
          component="img"
          alt="Cover Image"
          image={coverImageUrl ? coverImageUrl : DefaultHeader}
          title="Cover Image"
        />
      </Card>
      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        style={{ marginTop: '-70px' }}
      >
        <ProfilName info={info} closeModal={closeModal} />
      </Grid>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Divider />
          <Contact info={info} shareClassroom={shareClassroom} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Criteria info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Description info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Education info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Experience info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <CompetenciesPro info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <CompetenciesPerso info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Software info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <LanguageProg info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Language info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Certification info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Achievement info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Interest info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Transport info={info} />
          <Divider />
        </Grid>
        <Grid item xs={12}>
          <Permit info={info} />
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
  container: {
    height: '100%',
  },
});

Detailed.propTypes = {
  info: PropTypes.string,
  closeModal: PropTypes.func,
  coverImageUrl: PropTypes.string,
};

export default Detailed;
